import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedContent from './components/FeaturedContent';
import CategoryGrid from './components/CategoryGrid';
import StatsCounter from './components/StatsCounter';
import FAQAccordion from './components/FAQAccordion';
import CTABanner from './components/CTABanner';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '91制片厂',
    url: 'https://www.91pianzhi.com',
    description: '91制片厂是专注优质影视内容创作与发行的专业平台，汇聚海量原创视频资源，为用户提供高清流畅的观看体验。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.91pianzhi.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '91制片厂',
    url: 'https://www.91pianzhi.com',
    description: '专注优质影视内容创作与发行的专业平台',
    foundingDate: '2018',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-xxx-xxxx',
      contactType: 'customer service',
      email: 'service@91pianzhi.com',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '建国路88号SOHO现代城A座15层',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedContent />
        <CategoryGrid />
        <StatsCounter />
        <FAQAccordion />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
}